<template>
    <div class="coupon scrollstyle">
        <div class="coupon-title">
            {{ $t('coupons_text1') }}
        </div>
        <div v-if="!isCheckBX" style="display: flex;flex-direction: column;align-items: center;">
            <n-alert  type="info" style="margin-bottom: 20px;">
                {{ $t('coupons_text8') }}
            </n-alert>
            <base-ex ref="baseEXE" style="width: 311px;"></base-ex>
            <n-button type="info" @click="validForm()" :disabled="!isFormFinsh">{{ $t('coupons_text9') }}</n-button>
        </div>
        <template v-else>
            <div class="coupon-input">
                <n-form ref="formRef" :model="formValue" :rules="rules">
                    <n-form-item path="coupon">
                        <n-input round v-model:value="formValue.coupon" :placeholder="$t('discovery_3')" size="large">
                            <template #prefix>
                                <n-icon :component="TicketOutline" size="20" color="#757575" />
                            </template>
                            <template #suffix>
                                <n-button strong round type="info" size="small" @click="handleValidateClick" class="coupon-input-btn">
                                    {{ $t('coupons_text2') }}
                                </n-button>
                            </template>
                        </n-input>
                    </n-form-item>
                </n-form>
            </div>
            <div class="coupons-title">{{ $t('coupons_text3') }}</div>
            <n-tabs default-value="activeCoupons" justify-content="space-evenly" type="card" class="custom-tabs">
                <!-- 未使用 -->
                <n-tab-pane name="activeCoupons" :tab="$t('coupons_text4')">
                    <div v-if="activeCoupons.length <= 0" class="noCoupons">
                        <n-icon :component="TicketOutline" size="30" color="#757575" style="margin-bottom: 10px"/> 
                        {{ $t('coupons_text5') }}
                    </div>
                    <div class="coupons-box" v-else>
                        <!-- <my-coupon v-for="(c, index) in eventCoupons" :key="index" :cInfo="c" /> -->
                        <my-coupon v-for="(c, index) in activeCoupons" :key="index" :cInfo="c" />
                    </div>
                </n-tab-pane>
                <!-- 已使用或已過期 -->
                <n-tab-pane name="inactiveCoupons" :tab="$t('coupons_text6')">
                    <div v-if="inactiveCoupons.length <= 0" class="noCoupons">
                    <n-icon :component="TicketOutline" size="30" color="#757575" style="margin-bottom: 10px"/> 
                    {{ $t('coupons_text5') }}
                    </div>
                    <div class="coupons-box" v-else>
                        <my-coupon v-for="(c, index) in inactiveCoupons" :key="index" :cInfo="c" />
                    </div>
                </n-tab-pane>
            </n-tabs>
        </template>
    </div>
</template>

<script>
import { ref, inject, defineComponent, computed } from 'vue'
import { useStore } from "vuex"
import { TicketOutline,} from '@vicons/ionicons5'
import { useI18n } from "vue-i18n"
import naiveFnc from "@/utils/naiveFnc";
import mycoupon from '@/components/coupon.vue'
import baseex from '@/components/baseEX.vue'
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
    components: {
        'my-coupon': mycoupon,
        'base-ex': baseex
    },
    setup() {
        // 全螢幕的spin
        const changeSpinState = inject('changeSpinState')
        const router = useRouter();
        const route = useRoute();
        const { crtDialog } = naiveFnc();
        const i18n = useI18n();
        const { t } = i18n;
        const store = useStore()
        const formValue= ref({
            coupon: ""
        })
        const rules= {
            coupon: {
                required: true,
                message: t('discovery_3'),
                trigger: ["input"]
            }
        }
        const formRef = ref(null)
        const baseEXE = ref()
        const eventCouponIds = store.state.coreApi.eventCouponIds
        const coupons = computed(() => store.getters["coreApi/coupons"]);
        const events = computed(() => store.getters["coreApi/events"]);
        const isCheckBX = computed(() => store.getters["coreApi/isCheckBX"]);
        const eventCoupons = computed(() => store.getters["coreApi/eventCoupons"]);
        const baseEXCheckKey = computed(() => store.getters["coreApi/baseEXCheckKey"]);
        const baseEx = computed(() => store.getters['coreApi/baseEx']);
        const benifits = store.getters['coreApi/benifits']

        // 設定都完成按鈕亮燈
        const isFormFinsh = computed(()=>{
            let flag = true
            baseEXCheckKey.value.forEach(c=>{
                switch(c){
                    case 'schoolCode':
                        // 暫不檢查
                        // if(baseEXE.value?.baseExValue['country'] == 'TW' && (baseEXE.value?.baseExValue[c] == '' || baseEXE.value?.baseExValue[c] == null)){
                        //     flag = false
                        // }
                    break
                    default:
                        if(baseEXE.value?.baseExValue[c] == '' || baseEXE.value?.baseExValue[c] == null) {
                            flag = false
                        }
                }
            })
            return flag
        })        

        // 篩選過期與已使用
        const inactiveCoupons = computed(()=>{
            let res = []
            coupons.value.forEach( c =>{
                if( c.isExchange || c.isExpired) {
                    res.push(c)
                }
            })

            eventCoupons.value.forEach(c => {
                if( c.isExchange || c.isExpired) {
                    res.push(c)
                }
            })

            res.sort(function(a, b) {
                return a.endTime > b.endTime ? 1 : -1;
            })

            return res
        })

        // 篩選可使用的
        const activeCoupons = computed(()=>{
            let res = []

            eventCoupons.value.forEach(x => {
                // 如果此券已過期或被兌換則跳出
                if(x.isExchange || x.isExpired){
                    return
                }

                // 找到的筆數
                let exist = 0

                // 查找活動是否有存在
                let temp = events.value.filter( y => {
                    return y.name.toLocaleLowerCase() == x.code.toLocaleLowerCase()
                })
                exist += temp.length

                // 查找優惠券是否有存在
                temp = coupons.value.filter( y => {
                    return y.code.toLocaleLowerCase() == x.code.toLocaleLowerCase()
                })
                exist += temp.length

                // hiteach333 與 hiteach50 為擇一券
                if(x.code.toLocaleLowerCase() == 'hiteach50') {
                    temp = events.value.filter( y => {
                        return (y.name.toLocaleLowerCase() == 'hiteach333' || y.name.toLocaleLowerCase() == 'hiteach50')
                    })
                    exist += temp.length
                }

                // 檢核雙AI券 soklite
                if(x.code.toLocaleLowerCase() == 'soklite-2026') {
                    // 如果權益結束時間 大於 2027/1/1 代表已換過
                    temp = benifits.hiteach.filter( x => (x.func === "soklite" && x.exp > 1798761600))
                    exist += temp.length
                }
                
                // 檢核雙AI券 aitext
                if(x.code.toLocaleLowerCase() == 'aitext-2026') {
                    // 如果權益結束時間 大於 2027/1/1 代表已換過
                    temp = benifits.hiteach.filter( x => (x.func === "aitext" && x.exp > 1798761600))
                    exist += temp.length
                }

                // 都沒找到就加入
                if(exist == 0) {
                    res.unshift(x)
                }
            })

            // 提取未過期與未兌換的券
            coupons.value.forEach( c =>{
                if(!c.isExchange && !c.isExpired) {
                    res.push(c)
                }
            })

            // 依據到期日排序
            res.sort(function(a, b) {
                return a.expire > b.expire ? 1 : -1;
            })

            return res
        })

        function handleValidateClick(e) {
            e.preventDefault();
            formRef.value?.validate((errors) => {
                if (!errors) {
                    exchangeCoupon(formValue.value.coupon);
                }
            });
        }

        // 取得優惠券
        async function exchangeCoupon(couponCode) {
            changeSpinState() // 開啟全屏spin

            // 呼叫API
            let res = await getCoupon(couponCode)
            if(res.state > 0){
                crtDialog(t('notice'), res.msg)
            } else {
                let result = res.data
                let eventName = ''
                let eventStep = 0

                if(result.eventName != null && typeof result.eventName != 'undefined') {
                    let eventTemp = result.eventName.split('-')
                    eventName = eventTemp[0].toLocaleLowerCase()
                    eventStep = eventTemp[1]
                }

                // eventName 存在於 eventCouponIds 代表是特殊活動券
                if(eventName != '' && eventCouponIds.indexOf(eventName)  != -1) {
                    // 呼叫API 暫時決定為直接換到底 並且不存於setting裡面 
                    let evRes = await exchangeVoucher(result.voucher)
                    if(evRes.state > 0){
                        crtDialog(t('notice'), evRes.msg)
                    } else {
                        let temp = events.value.filter( y => y.name.toLocaleLowerCase() == eventName)
                        if(temp.length == 0) {
                            await store.dispatch("coreApi/setUserEvents", {name: eventName, step: 1, done: new Date().getTime()})
                        } else {
                            await store.dispatch("coreApi/updUserEvents", {name: eventName, step: Number(eventStep), done: new Date().getTime()})
                        }

                        if(eventName == 'hiteach50' || eventName == 'hiteach333') {
                            if(eventStep == "1") {
                                crtDialog(t('discovery_9'), t('event3_text1'))
                            } else {
                                crtDialog("", t('discovery_9'))
                            }                            
                            router.push({ name: 'event3', params: { lang: route.params.lang } });
                        } else {
                            crtDialog("", t('discovery_9'))
                        }
                    }
                } else {
                    let ticket = {
                        type: "V",
                        code: result.voucher,   // 兌換卷號
                        info: [ // 兌換券資訊 l:語系, n:標題, u:連結
                            {"l":"zh-tw","n":"","u":""},
                            {"l":"zh-cn","n":"","u":""},
                            {"l":"zn-us","n":"","u":""}
                        ], 
                        expire: result.expire, // 到期日
                        isExchange: false,// 是否被兌換
                        isExpired: false, // 是否已過期
                        endTime: -1,      // 結束時間(包含兌換與過期時間，預計保留半年)
                        eventName: eventName
                    }

                    if(result.info) {
                        ticket.info = JSON.parse(result.info)
                    }

                    store.dispatch('coreApi/setUserCoupons', ticket)
                    crtDialog("", t('coupons_text7'))
                }

                await store.dispatch("coreApi/setUsersetting") // 儲存現在的usersetting
            }

            formValue.value.coupon = '' // 清空輸入欄位
            changeSpinState()  // 關閉全屏spin 
        }

        async function getCoupon(code){
            let errStr = ''
            let data = {}
            await store.dispatch('coreApi/getCoupon', code).then( res => {
                if(res.error) {
                    let error = res.error.toString()
                    switch(error) {
                        case '9':
                            errStr = t('error_9')
                        break
                        case '14':
                            errStr = t('error_10')
                        break
                        case '15':
                            errStr = t('error_11')
                        break
                        case '20':
                            errStr = t('error_12')
                        break
                    }
                } else {
                    data = res
                }
            }).catch( () =>{
                errStr = t('error_3')
            })

            if(errStr != ''){
                return {state: 1, msg: errStr}
            } else {
                return {state: 0, data: data}
            }
        }

        async function exchangeVoucher(voucher){
            let errStr = ''
            await store.dispatch('coreApi/exchangeVoucher', voucher).then( res => {
                if(res.error) {
                    let error = res.error.toString()
                    switch(error) {
                        // case '8':
                        //   errStr = '票卷已過期'
                        // break
                        // case '9':
                        //   errStr = '你已使用過該票券'
                        // break
                        // case '12':
                        //     errStr = '活動尚未開始'
                        // break
                        // case '16':
                        //     errStr = '降規格(權益折損)'
                        // break
                        default:
                        errStr = t('error_10')
                    }
                }
            }).catch( () =>{
                errStr = t('error_3')
            })

            if(errStr != ''){
                return {state: 1, msg: errStr}
            } else {
                return {state: 0, msg: ''}
            }
        }
        const validForm = ()=>{
            baseEXE.value.baseExFormRef.validate(
                async(errors) => {
                    if (!errors) {
                        changeSpinState() // 開啟全屏spin
                        let data = {}
                        if(baseEx.value){
                            let bKeys = Object.keys(baseEx.value)

                            bKeys.forEach(k=>{
                                if(baseEXE.value.baseExValue[k]) {
                                    data[k] = baseEXE.value.baseExValue[k]
                                } else {
                                    data[k] = baseEx.value[k]
                                }
                            })
                        } else {
                            data = baseEXE.value.baseExValue
                        }                        

                        store.dispatch('coreApi/updIsCheckBX', true)
                        await store.dispatch("coreApi/setUsersetting") // 儲存現在的usersetting

                        // 寫入baseEX
                        await store.dispatch('coreApi/setUserContact', data).then(() => {
                            changeSpinState() // 關閉全屏spin
                        }).catch(e =>{
                            console.log(e)
                        })
                    }
                }
            )
        }
        
        return {
            TicketOutline,
            formValue,
            rules,
            formRef,
            handleValidateClick,
            eventCoupons,
            activeCoupons,
            inactiveCoupons,
            baseEXE,
            validForm,
            isFormFinsh,
            isCheckBX
        }
    },
})
</script>
<style lang="less" scoped>
.coupon {
    padding-top: 24px;
    &-title{
        font-size: 20px;
        letter-spacing: 2px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 20px;
        color: #03c5fb;
        font-family: monospace;
    }
    &-input{
        margin-bottom: 20px;
        .n-input {
            --n-border-hover:1px solid transparent!important;
            --n-border-focus:1px solid transparent!important;
            --n-box-shadow-focus: 0 0 0 2px #dadddb40!important;
            --n-caret-color: #333!important;
        }
        &-btn{
            background-color: #03a9f4;
        }
    }
    .coupons-title{
        font-size: 17px;
        margin-bottom: 3px;
    }
    .noCoupons{
        height: 200px;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #9E9E9E;
        flex-direction: column;
    }
    .coupons-box{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: 0 5px;
    }
}

</style>
<style lang="less">
.custom-tabs {
    --n-tab-text-color-hover: #1f2225!important;
    --n-tab-text-color-active: #1f2225!important;
    --n-bar-color: #03a9f4!important;
    --n-tab-border-color: #bdbdbd!important;
    .n-tabs-tab.n-tabs-tab--active{
        .n-tabs-tab__label{
            font-size: 15px;
        }
    }
}
</style>